<template>
  <aside class="app-sidebar">
    <div class="sidebar-logo">
      <img class="sidebar-logo-img" :src="logo" alt="DisplayDeck">
    </div>
    <nav class="sidebar-nav">
      <router-link v-for="item in navItems" :key="item.to" :to="item.to"
                   class="sidebar-nav-item" :class="{ 'sidebar-nav-item-root': item.to === '/' }"
                   :data-tour="item.tour || null"
                   @click="$emit('navigate')">
        <span class="sidebar-nav-icon" v-html="getSVG(item.icon)" />
        {{ item.label }}
      </router-link>
    </nav>
    <div class="sidebar-footer" ref="footer">
      <button class="sidebar-user" @click="popoverOpen = !popoverOpen">
        <span class="sidebar-avatar">{{ initials }}</span>
        <span class="sidebar-user-meta">
          <span class="sidebar-user-name">{{ user.firstName }} {{ user.lastName }}</span>
          <span class="sidebar-user-role">{{ roleLabel }}</span>
        </span>
        <span class="sidebar-user-chevron" v-html="getSVG('chevron_down')" />
      </button>
      <ProfilePopover v-if="popoverOpen" @close="popoverOpen = false" />
    </div>
  </aside>
</template>
<script>
import ProfilePopover from './ProfilePopover.vue';
export default {
  components: { ProfilePopover },
  emits: ['navigate'],
  data() { return { popoverOpen: false }; },
  computed: {
    logo() { return require('@/assets/img/logo-dd.svg'); },
    user() { return this.$store.state.user || {}; },
    initials() {
      return ((this.user.firstName || '?')[0] + (this.user.lastName || '?')[0]).toUpperCase();
    },
    roleLabel() {
      const r = this.user.role;
      return r === 'super_admin' ? 'Superadmin' : r === 'admin' ? 'Administrator' : 'Mitarbeiter';
    },
    isAtLeastAdmin() {
      const r = this.$store.state.user?.role;
      return r === 'admin' || r === 'super_admin';
    },
    isSuperAdmin() {
      return this.$store.state.user?.role === 'super_admin';
    },
    isEditor() {
      const user = this.$store.state.user;
      if(!user) {
        return false;
      }
      if(user.role === 'admin' || user.role === 'super_admin') {
        return true;
      }
      return Object.values(user.groupsFull || {}).some(item => item.isAdmin);
    },
    navItems() {
      const items = [
        { to: '/',          icon: 'nav_dashboard', label: 'Dashboard' },
        { to: '/screens',   icon: 'nav_displays',  label: 'Displays',  tour: 'screens' },
        { to: '/playlists', icon: 'nav_playlists', label: 'Playlists', tour: 'playlists' },
        { to: '/library',   icon: 'nav_media',     label: 'Media',     tour: 'library' },
        { to: '/generator', icon: 'nav_generator', label: 'Generator' },
      ];
      if (this.isEditor) items.push({ to: '/releaseRequests', icon: 'nav_redaktion', label: 'Redaktion' });
      if (this.isAtLeastAdmin) items.push({ to: '/users', icon: 'nav_users', label: 'Users' });
      if (this.isSuperAdmin) items.push({ to: '/settings', icon: 'nav_settings', label: 'Einstellungen' });
      return items;
    },
  },
  methods: {
    onDocClick(e) {
      if (this.popoverOpen && this.$refs.footer && !this.$refs.footer.contains(e.target)) this.popoverOpen = false;
    },
  },
  mounted() { document.addEventListener('click', this.onDocClick); },
  unmounted() { document.removeEventListener('click', this.onDocClick); },
}
</script>
